/**
 * OIB check digit, ISO 7064 MOD 11-10 — the same algorithm as the backend.
 *
 * Duplicated here on purpose, and only here. The point is telling somebody
 * while they are still looking at the field, rather than after they press
 * save: a wrong OIB travels to JOPPD and is discovered months later by
 * somebody else. The server checks it again regardless — this copy is
 * convenience, not authority, which is why it is a dozen lines and has its own
 * tests against the same known values.
 */

export function kontrolnaZnamenka(prvihDeset: string): number {
  let ostatak = 10;
  for (const znamenka of prvihDeset) {
    ostatak = (ostatak + Number(znamenka)) % 10;
    if (ostatak === 0) ostatak = 10;
    ostatak = (ostatak * 2) % 11;
  }
  const kontrolna = 11 - ostatak;
  return kontrolna === 10 ? 0 : kontrolna;
}

export function oibIspravan(oib: string): boolean {
  if (!/^\d{11}$/.test(oib)) return false;
  return Number(oib[10]) === kontrolnaZnamenka(oib.slice(0, 10));
}

export const OIB_PORUKA =
  "OIB nije ispravan. Provjerite je li upisano točno 11 znamenki i je li kontrolna znamenka točna.";
